var _ellipse, _ellipse2, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7202,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "#CED4DA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2847_38656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7202,
    cy: 24,
    rx: 24.0698,
    ry: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2847_38656)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.6504,
    y: -0.999992,
    width: 8,
    height: 54,
    transform: "rotate(32 34.6504 -0.999992)",
    fill: "white",
    fillOpacity: 0.101961
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2847_38656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0537 24C13.0537 17.56 18.2687 12.3333 24.7087 12.3333C31.1604 12.3333 36.387 17.56 36.387 24C36.387 30.44 31.1604 35.6667 24.7087 35.6667C18.2687 35.6667 13.0537 30.44 13.0537 24ZM24.7204 28.025L28.477 30.2883C28.9204 30.5567 29.457 30.16 29.3404 29.6583L28.3487 25.3767L31.6504 22.5183C32.047 22.18 31.837 21.5383 31.3237 21.4917L26.9604 21.1183L25.257 17.105C25.0587 16.6267 24.382 16.6267 24.1837 17.105L22.4804 21.13L18.117 21.5033C17.6037 21.55 17.3937 22.1917 17.7787 22.53L21.0804 25.3883L20.0887 29.6583C19.972 30.16 20.5204 30.5567 20.9637 30.2883L24.7204 28.025Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2847_38656)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.7197,
    y: 10,
    width: 28,
    height: 28,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReview);
export default __webpack_public_path__ + "static/media/NoReview.9d27c6cf.svg";
export { ForwardRef as ReactComponent };